// extracted by mini-css-extract-plugin
export default {"DateConsultation":"EditionDate_DateConsultation__ZatVt","DatePicker":"EditionDate_DatePicker__YNck1"};